"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var monitoring_1 = require("../../services/monitoring");
var ProgressSpinner_1 = require("../ProgressSpinner/ProgressSpinner");
var FormControl = /** @class */ (function (_super) {
    __extends(FormControl, _super);
    function FormControl(props) {
        var _this = _super.call(this, props) || this;
        _this.refHandlers = {
            prefix: function (ref) {
                if (ref) {
                    var newWidth = ref.getBoundingClientRect().width;
                    if (newWidth !== _this.state.prefixWidth) {
                        _this.setState({
                            prefixWidth: newWidth
                        });
                    }
                }
            },
            suffix: function (ref) {
                if (ref) {
                    var newWidth = ref.getBoundingClientRect().width;
                    if (newWidth !== _this.state.suffixWidth) {
                        _this.setState({
                            suffixWidth: newWidth
                        });
                    }
                }
            }
        };
        _this.state = {
            prefixWidth: 0,
            suffixWidth: 0
        };
        return _this;
    }
    FormControl.prototype.componentDidMount = function () {
        monitoring_1.default('formControl');
    };
    FormControl.prototype.render = function () {
        var _a = this.props, placeholder = _a.placeholder, layout = _a.layout, controlElements = _a.children, disabled = _a.disabled, required = _a.required, label = _a.label, column = _a.column, prefix = _a.prefix, suffix = _a.suffix, hint = _a.hint, value = _a.value, loading = _a.loading, validationMethod = _a.validationMethod, showValidation = _a.showValidation, size = _a.size, className = _a.className, style = _a.style;
        var _b = this.state, prefixWidth = _b.prefixWidth, suffixWidth = _b.suffixWidth;
        var validationResult = '';
        var validationMessage = hint;
        if (showValidation &&
            value !== undefined &&
            validationMethod !== undefined) {
            var validationMethodResult = validationMethod(value);
            if (validationMethodResult && validationMethodResult.result) {
                validationResult = validationMethodResult.result;
                validationMessage = validationMethodResult.message;
            }
        }
        var formControlClasses = classNames('form-control', {
            'form-control--neutral': validationResult === 'process' || validationResult === 'neutral',
            'form-control--success': validationResult === 'success',
            'form-control--caution': validationResult === 'caution',
            'form-control--error': validationResult === 'error',
            'form-control--info': validationResult === 'info',
            'form-control--label-left': layout === 'horizontal',
            'form-control--small': size === 'small',
            'form-control--required': required,
            'form-control--has-prefix': prefixWidth > 0,
            'form-control--has-suffix': suffixWidth > 0,
            'form-control--has-large-prefix': prefixWidth > 20,
            'form-control--has-large-suffix': suffixWidth > 20
        }, "form-control--column-" + column, className);
        return (React.createElement("div", { className: formControlClasses, style: style },
            label && React.createElement(FormControlLabel, null, label),
            React.createElement("div", { className: "form-control__content" },
                prefix && (React.createElement("div", { className: "form-control__content__prefix", ref: this.refHandlers.prefix }, prefix)),
                controlElements,
                (loading || suffix) && (React.createElement("div", { className: "form-control__content__suffix", ref: this.refHandlers.suffix }, loading ? React.createElement(ProgressSpinner_1.default, { size: 'extra-small' }) : suffix)),
                validationMessage && (React.createElement(FormControlHint, null, validationMessage)))));
    };
    FormControl.defaultProps = {
        disabled: false,
        required: false,
        showValidation: true,
        column: 1
    };
    return FormControl;
}(React.Component));
exports.default = FormControl;
var FormControlLabel = function (props) {
    return React.createElement("label", { className: "form-control__label" }, props.children);
};
var FormControlHint = function (props) {
    return React.createElement("p", { className: "form-control__hint" }, props.children);
};
//# sourceMappingURL=FormControl.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/FormControl/FormControl.js
// module id = 270
// module chunks = 0